import styled, {keyframes} from 'styled-components';

const enterAnim = keyframes`
  from{opacity: 0;}
  to{opacity: 1;}
`;

export const SlideWrapper = styled.div`
  height: 35rem;
  width: 100%;
  position: relative;
`;

export const SlidePrimeText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 4rem;
  line-height: 0.9;
  font-family: 'LEMONMILKBOLD';
  white-space: nowrap;
  p:nth-child(1) {
    color: #a3c0c0;
  }
  p:nth-child(2) {
    color: #e09087;
  }
  p:nth-child(3) {
    color: #e0c887;
  }
`;

export const SlideSecondaryTextWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 10rem;
`;

export const SlideSecondaryLogo = styled.img`
  height: 123%;
  opacity: 0;
  animation: ${enterAnim} 1.5s 1.5s forwards;
`;

export const SlideSecondaryText = styled.div`
  margin-left: 1.95rem;
  font-family: 'LEMONMILKBOLD';
  color: #d5d5d5;
  line-height: 1;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 101%;

  p:nth-child(1) {
    letter-spacing: 1px;
    font-size: 3.91rem;
    line-height: 0.85;
  }
  p:nth-child(2) {
    letter-spacing: 1px;
    font-size: 3rem;
  }
  p:nth-child(3) {
    letter-spacing: 1px;
    font-size: 2.27rem;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${({src}) => `url(${src})`};
  background-size: cover;
  background-position: center;
  outline: none;
`;

export const HaniaWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${({src}) => `url(${src})`};
  background-size: cover;
  background-position: center;
  background-position-x: 80%;
  outline: none;
`;

export const Dots = styled.ul`
  bottom: 30px;

  li {
    height: 25px;
    width: 25px;

    button {
      height: 25px;
      width: 25px;
      &::before {
        font-size: 20px;
        color: white !important;
      }
    }
  }
`;
